export enum PrimitiveDataSchemas {
    String = 'string',
    Number = 'number',
    Boolean = 'boolean',
    Any = 'any',
    Object = 'object'
}
